export default "__VITE_ASSET__D3qP6DcV__"